import {PAGES} from "../../../../../core/consts";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {CompetitionLinkParams} from "../../../models/competition-link-params";
import {CompetitionContainerHashParamsModel} from "../../../models/competition-container.hash-params-model";

export class CompetitionStandingsPageLinkModel extends BaseLinkModel  {
  constructor(competitionId, sportName, competitionName, page, hashParams: CompetitionContainerHashParamsModel, isFollow: Boolean = true) {
    super(PAGES.COMPETITION.standings, new CompetitionLinkParams(competitionId, sportName, competitionName), false, null, null, hashParams);

    this.isFollow = isFollow;
  }
}